module.exports = "<loading *ngIf=\"loading\"></loading>"